import showMore from "../modules/show-more";

const initBlock = async function( block ) {
	showMore( block );
};

themeUtils.loadBlock( initBlock, "terms-and-conditions", ".section-terms-and-conditions" );
